/* global angular */
( function () {
	'use strict';

	function obsPdfModal ( $modal, observationPdf ) {
		function linkFn ( scope, elem ) {
			var observation = scope.vm.data || scope.vm.obsData;

			function setModalTitle () {
				return 'Export Observation';
			}

			function setFileTypes () {
				return [ 'PDF' ];
			}

			function setFileNameIndex () {
				return 1;
			}

			function setFileName () {
				return observation.name.split( ' ' ).join( '.' );
			}

			function showOptionsFn ( showOptions, fileName ) {
				var isPreview = scope.vm.title === 'Template Preview';

				observationPdf.generatePdf( observation, showOptions, fileName, isPreview );
			}

			function generatePdf () {
				return showOptionsFn;
			}

			function onClickFn () {
				$modal.open( {
					'templateUrl'  : '/templates/observations/observation-preview/pdf-export-modal/export-modal.html',
					'controller'   : 'ObsPdfExportModalCtrl',
					'controllerAs' : 'vm',
					'resolve'      : {
						'title'         : setModalTitle,
						'fileTypes'     : setFileTypes,
						'fileNameIndex' : setFileNameIndex,
						'generatePdf'   : generatePdf,
						'filename'      : setFileName
					}
				} );
			}

			elem.click( 'click', onClickFn );
		}
		return {
			'restrict' : 'A',
			'link'     : linkFn
		};
	}

	obsPdfModal.$inject = [ '$modal', 'observationPdf' ];

	angular
		.module( 'app.components' )
		.directive( 'obsPdfModal', obsPdfModal );
} )();
